import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ChevronDown } from 'lucide-react';
import { SectionTitle, FlowerMotif } from './premium/Decor';

const FAQS = [
  { qHi: 'कुंडली रिपोर्ट कितने समय में मिलेगी?', qEn: 'How long until I receive the report?',
    aHi: 'आपको अपनी प्रीमियम कुंडली रिपोर्ट 48 घंटे के अंदर email पर मिल जाएगी।',
    aEn: 'You will receive your premium Kundli report within 48 hours via email.' },
  { qHi: 'क्या यह कुंडली सटीक होगी?', qEn: 'Will the Kundli be accurate?',
    aHi: '100% वैदिक ज्योतिष पर आधारित — हमारे अनुभवी ज्योतिषाचार्य द्वारा manually तैयार की जाती है।',
    aEn: '100% Vedic-astrology-based — manually crafted by our experienced astrologer.' },
  { qHi: 'रिपोर्ट में क्या-क्या शामिल है?', qEn: 'What is included in the report?',
    aHi: 'जन्म कुंडली, 12 भाव, दशा विश्लेषण, विवाह, करियर, धन, स्वास्थ्य, दोष-उपाय, रत्न, मंत्र — सब कुछ।',
    aEn: 'Birth chart, 12 houses, dasha analysis, marriage, career, wealth, health, doshas-remedies, gems, mantras — everything.' },
  { qHi: 'पेमेंट के कौन से तरीके हैं?', qEn: 'What are the payment methods?',
    aHi: 'UPI, Debit/Credit Card, Net Banking, Digital Wallet — सभी 100% सुरक्षित Razorpay से।',
    aEn: 'UPI, Debit/Credit Card, Net Banking, Digital Wallet — all 100% secure via Razorpay.' },
  { qHi: 'जन्म का सही समय जरूरी है?', qEn: 'Is exact birth time necessary?',
    aHi: 'सटीक कुंडली के लिए जन्म का सही समय बहुत ज़रूरी है। अनुमानित समय भी चलेगा।',
    aEn: 'Exact birth time gives the most accurate Kundli. An approximate time also works.' },
  { qHi: 'भाषा कौन सी मिलेगी?', qEn: 'Which language will the report be in?',
    aHi: 'आप form भरते समय हिंदी या English चुन सकते हैं — आपकी पूरी रिपोर्ट उसी भाषा में होगी।',
    aEn: 'You can choose Hindi or English while filling the form — your entire report will be in that language.' },
  { qHi: '₹99 ही क्यों? Catch क्या है?', qEn: 'Why only ₹99? Whats the catch?',
    aHi: 'कोई catch नहीं — हम स्थापित होने के लिए launch offer पर हैं। बहुत जल्द price ₹999 हो जाएगी।',
    aEn: "There's no catch — this is a limited launch offer. Price returns to ₹999 very soon." },
];

const FAQSection = () => {
  const { language } = useLanguage();
  const [open, setOpen] = useState(0);
  const isHi = language === 'hi';

  return (
    <section className="relative bg-white py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          eyebrow={isHi ? 'सामान्य प्रश्न' : 'Common Questions'}
          title={isHi ? 'अक्सर पूछे जाने वाले सवाल' : 'Frequently Asked Questions'}
          subtitle={isHi ? 'जो आप जानना चाहते हैं — सब यहाँ है।' : 'Everything you might want to know.'}
          language={language}
        />

        <div className="mt-12 space-y-3">
          {FAQS.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                data-testid={`faq-item-${i}`}
                className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                  isOpen
                    ? 'border-brand-gold bg-gradient-to-br from-brand-cream via-white to-brand-gold-light/15 shadow-gold-glow'
                    : 'border-brand-gold/25 bg-white hover:border-brand-gold/50'
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left"
                >
                  <div className="flex items-start gap-3.5 min-w-0">
                    <FlowerMotif className={`w-5 h-5 mt-0.5 flex-shrink-0 transition-colors ${isOpen ? 'text-brand-gold-dark' : 'text-brand-gold/50'}`} />
                    <h3 className={`font-semibold text-base md:text-lg text-brand-text-dark ${isHi ? 'font-hindi' : 'font-outfit'}`}>
                      {isHi ? faq.qHi : faq.qEn}
                    </h3>
                  </div>
                  <ChevronDown
                    className={`w-5 h-5 text-brand-maroon flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className={`px-5 md:px-6 pb-6 pl-14 text-brand-text-soft text-sm md:text-base leading-relaxed ${isHi ? 'font-hindi' : 'font-outfit'}`}>
                      {isHi ? faq.aHi : faq.aEn}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
